import { useIntl } from '@/intl'
import { Block, Header } from './Blocks'
import styles from './WorldSkiAward.module.css'

interface WorldSkiAwardProps {
  href: string
  className?: string
}

export function WorldSkiAward({ href, className }: WorldSkiAwardProps) {
  const intl = useIntl()

  return (
    <Block className={className}>
      <Header>{intl.formatMessage({ id: 'footer_winter_world_ski_award_title' })}</Header>
      <a href={href} className={styles.link}>
        <img
          className={styles.image}
          alt={intl.formatMessage({ id: 'footer_winter_world_ski_award_label' })}
          src="/-/media/06_ski-pwh/world-ski-awards/wsa-2025-26/br1683_worldskiawards-footer-logos_2025.ashx?h=152&w=471&la=nl-NL&hash=08DE85B2A6B7F8F32DC3711D19C605D1"
        />
      </a>
    </Block>
  )
}
